import React, { Component } from 'react';
import { Form} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';

class DepartmentForm extends Component {
    constructor() {
        super();
        this.state = {
            errInputMsg: {}
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            errInputMsg: nextProps.isError
        });
    }

    handleChangeInput = (evt) =>{
        this.props.changeDepartment(evt);
    }
    
    render() {
        const { departmentData, t } = this.props;
        return (            
            <div className="employee-form">
                <Form>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.departmentCode')}</label>
                        <Form.Input name="departmentCode" maxLength="12" 
                            value={departmentData.departmentCode} 
                            onChange={e => {this.handleChangeInput(e)}}
                        />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['departmentCode'])}</div>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.description')}</label>
                        <Form.Input name="departmentName" 
                            value={departmentData.departmentName} 
                            onChange={e => {this.handleChangeInput(e)}}
                            maxLength="50"
                        />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['departmentName'])}</div>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(DepartmentForm);
